module.exports = __webpack_public_path__ + "static/media/camera-offline-dead-battery.6a2f688e.png";